var redefine = require(68);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};